/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './style.cssmodule.css';
import { ReactComponent as CheckIcon } from './icons/check.svg';
import { ReactComponent as TiretIcon } from './icons/tiret.svg';

function Checkbox({
  name,
  children,
  id,
  focusable,
  disabled,
  checked,
  onChange,
}) {
  return (
    <div className={styles.checkboxContainer}>
      <label htmlFor={id || name} style={{ position: 'relative', lineHeight: 0 }}>
        <input
          type="checkbox"
          tabIndex={focusable ? 0 : -1}
          className={styles.checkbox}
          name={name}
          id={id || name}
          disabled={disabled}
          checked={checked}
          onChange={onChange}
        />
        {disabled && !checked ? (
          <TiretIcon className={styles.iconInside} />
        ) : (
          <CheckIcon className={styles.iconInside} />
        )}
      </label>
      {children ? <label htmlFor={id || name} className={styles.label}>{children}</label> : null}
    </div>
  );
}

Checkbox.propTypes = {
  name: PropTypes.string,
  children: PropTypes.string,
  id: PropTypes.string,
  disabled: PropTypes.bool,
  focusable: PropTypes.bool,

  checked: PropTypes.bool,
  onChange: PropTypes.func,
};

Checkbox.defaultProps = {
  name: null,
  children: null,
  id: null,
  disabled: false,
  focusable: false,
  checked: false,
  onChange: null,
};

export default Checkbox;



// WEBPACK FOOTER //
// ./components/inputs/Checkbox/Checkbox.jsx